module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-5a492a94.png";